import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../components/shared/SectionTitle';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { heroImages } from '../data/mock';
import { Clock, Calendar, Users, MapPin, ArrowRight } from 'lucide-react';

const EntrainementsPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={heroImages.evenements}
            alt="Entraînements"
            className="w-full h-full object-cover"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
        </div>
        <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 tracking-tight drop-shadow-lg">
            Entraînements
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto drop-shadow">
            Sorties running au départ du magasin
          </p>
        </div>
      </section>

      {/* Coming Soon */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-4 py-2 rounded-full text-sm font-medium mb-8">
            <Clock className="w-4 h-4" />
            Projet en préparation
          </div>
          
          <h2 className="text-3xl md:text-4xl font-neuropolitical font-bold text-gray-900 mb-6">
            Bientôt : Sorties Running
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed mb-8">
            Nous préparons l'organisation de sorties running régulières au départ du magasin. 
            Ce projet sera lancé à la <strong>rentrée 2025</strong>.
          </p>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <SectionTitle
            title="Ce qui vous attend"
            subtitle="Le programme de nos futures sorties"
          />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10">
            <Card>
              <CardContent className="p-6 text-center">
                <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <Calendar className="w-7 h-7 text-emerald-700" />
                </div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2">Sorties régulières</h3>
                <p className="text-gray-600 text-sm">Des rendez-vous hebdomadaires pour courir ensemble</p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6 text-center">
                <div className="w-14 h-14 bg-sky-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <Users className="w-7 h-7 text-sky-700" />
                </div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2">Tous niveaux</h3>
                <p className="text-gray-600 text-sm">Des groupes adaptés à chaque niveau de pratique</p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6 text-center">
                <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <MapPin className="w-7 h-7 text-amber-700" />
                </div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2">Parcours variés</h3>
                <p className="text-gray-600 text-sm">Découvrez les plus beaux sentiers de la région</p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6 text-center">
                <div className="w-14 h-14 bg-rose-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <svg className="w-7 h-7 text-rose-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2">Convivialité</h3>
                <p className="text-gray-600 text-sm">L'esprit Foulées Vertes : partage et bonne humeur</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-emerald-800 text-white">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-neuropolitical font-bold mb-4">
            Restez informés !
          </h2>
          <p className="text-emerald-100 mb-8">
            Suivez-nous sur les réseaux sociaux pour être prévenus du lancement 
            de nos sorties running à la rentrée 2025.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/rendez-vous">
              <Button size="lg" className="bg-white text-emerald-800 hover:bg-emerald-50 px-8">
                Nous contacter
                <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EntrainementsPage;
